document.addEventListener("DOMContentLoaded", () => {
	const debouncedChange = debounce((select) => {
		const option = select.options?.[select.selectedIndex];
		const selectedText = option?.textContent?.trim() || select.value;

		if (!selectedText) return;

		const body = JSON.stringify({
			attributes: {
				how_did_you_hear_about_us: selectedText,
			},
		});

		fetch(`${window.FoxThemeSettings.routes.cart_update_url}`, {
			...fetchConfig(),
			body,
		});
	}, 300);

	document.addEventListener("change", (event) => {
		const select = event.target.closest('[js-cart-question-note="select"]');
		if (!select) return;

		debouncedChange(select);
	});
});
